import React from 'react';
import PropTypes from 'prop-types';
import { FormGroup, Label, Input, FormFeedback } from 'reactstrap';
import classnames from 'classnames';

import './form_control_radio_toggle.scss';

const FormControlRadioToggle = ({
  input,
  id,
  required,
  label,
  meta: { touched, error },
  classNameContainer,
  className,
  name,
  fieldProps,
}) => {
  let validationState = null;
  let errorText = null;

  if (touched) {
    if (error) {
      validationState = 'danger';
      errorText = error;
    } else {
      validationState = 'success';
    }
  }

  return (
    <FormGroup
      row
      color={validationState}
      className={classnames(
        classNameContainer,
        'form-control-radio-toggle form-group-row d-flex flex-row',
      )}
    >
      {label && (
        <Label for={id} className="form-group-row__label">
          {required ? (
            <span>
              {label} <span className="text-orange">*</span>
            </span>
          ) : (
            label
          )}
        </Label>
      )}
      <div className="d-flex">
        <Input
          className={classnames(className, 'form-group-row__input')}
          name={name}
          type="radio"
          checked={input.value}
          value
          id={`${name}_true`}
          {...input}
          {...fieldProps}
        />
        <Label
          htmlFor={`${name}_true`}
          className="form-control-radio-toggle__label align-items-center d-flex"
        >
          <span className="form-control-radio-toggle__label-circle" />
          Yes
        </Label>
        <Input
          className={classnames(className, 'form-group-row__input')}
          name={name}
          id={`${name}_false`}
          type="radio"
          checked={!input.value}
          value={false}
          {...input}
          {...fieldProps}
        />
        <Label
          htmlFor={`${name}_false`}
          className="form-control-radio-toggle__label align-items-center d-flex"
        >
          <div className="form-control-radio-toggle__label-circle" />
          No
        </Label>

        <FormFeedback>{errorText}</FormFeedback>
      </div>
    </FormGroup>
  );
};

FormControlRadioToggle.propTypes = {
  className: PropTypes.string,
  classNameContainer: PropTypes.string,
  fieldProps: PropTypes.shape({}),
  id: PropTypes.string,
  input: PropTypes.shape({}),
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  meta: PropTypes.shape({}),
  options: PropTypes.arrayOf(PropTypes.shape({})),
  name: PropTypes.string,
  required: PropTypes.bool,
};

FormControlRadioToggle.defaultProps = {
  className: '',
  fieldProps: {},
  options: [],
  required: false,
};

export default FormControlRadioToggle;
